(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-colour"] && !Shopify.designMode) return;
  try {
    

function initPrintFinlandFilters(scope){

scope.querySelectorAll('[data-pf-filter-root]').forEach(function(root){

if(root.dataset.pfReady)return;root.dataset.pfReady='1';

const buttons=root.querySelectorAll('[data-pf-product-filter]'),cards=root.querySelectorAll('[data-pf-product-category]'),empty=root.querySelector('[data-pf-products-empty]');

buttons.forEach(btn=>btn.addEventListener('click',()=>{

const chosen=btn.dataset.pfProductFilter;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));

let shown=0;cards.forEach(card=>{card.hidden=chosen!=='all'&&!card.dataset.pfProductCategory.split(/\s+/).includes(chosen);if(!card.hidden)shown++;});if(empty)empty.hidden=shown!==0;

}));

const initialCategory=new URLSearchParams(window.location.search).get('category');

if(initialCategory){const target=Array.from(buttons).find(btn=>btn.dataset.pfProductFilter===initialCategory);if(target)target.click();}

});

}

initPrintFinlandFilters(document);

document.addEventListener('shopify:section:load',()=>initPrintFinlandFilters(document));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-header"]) return;
  try {
    

  function updateCurrentNavigation() {

    const path = value => value.replace(/\/+$/, '') || '/';

    const currentUrl = new URL(window.location.href);

    for (const nav of document.querySelectorAll('.pf-main-nav')) {

      const links = [...nav.querySelectorAll('a[href]')];

      const matchesPath = link => {

        const url = new URL(link.href, currentUrl);

        return url.origin === currentUrl.origin && path(url.pathname) === path(currentUrl.pathname) && (url.searchParams.get('view') || '') === (currentUrl.searchParams.get('view') || '');

      };

      const current = links.find(link => matchesPath(link) && new URL(link.href, currentUrl).hash && new URL(link.href, currentUrl).hash === currentUrl.hash)

        || links.find(link => matchesPath(link) && !new URL(link.href, currentUrl).hash);

      for (const link of links) {

        if (link === current) {

          link.setAttribute('aria-current', new URL(link.href, currentUrl).hash ? 'location' : 'page');

        } else {

          link.removeAttribute('aria-current');

        }

      }

      const info = nav.querySelector('.pf-info');
      const trigger = info?.querySelector('.pf-info-trigger');
      if (trigger) {
        if (info.querySelector('a[aria-current]')) trigger.setAttribute('aria-current', 'true');
        else trigger.removeAttribute('aria-current');
      }

    }

  }

  updateCurrentNavigation();

  window.addEventListener('hashchange', updateCurrentNavigation);

  window.addEventListener('pageshow', updateCurrentNavigation);

  document.addEventListener('shopify:section:load', updateCurrentNavigation);



let pfStickyObserver;

function initPfStickyHeader() {

  pfStickyObserver?.disconnect();

  const group = document.getElementById('header-group');

  const header = group?.querySelector('.pf-head');

  const announcement = group?.querySelector('.pf-head-announcement');

  if (!group || !header) return;

  const measure = () => {

    group.style.setProperty('--pf-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);

    document.documentElement.style.setProperty('--pf-sticky-header-height', `${header.getBoundingClientRect().height}px`);

  };

  measure();

  if ('ResizeObserver' in window) {

    pfStickyObserver = new ResizeObserver(measure);

    pfStickyObserver.observe(header);

    if (announcement) pfStickyObserver.observe(announcement);

  }

}

initPfStickyHeader();

window.addEventListener('pageshow', initPfStickyHeader);

document.addEventListener('shopify:section:load', initPfStickyHeader);


// A navigation disclosure, using ordinary links rather than application-menu roles.
function initPfHeaderInfo(scope = document) {
  scope.querySelectorAll('.pf-head').forEach(header => {
    const info = header.querySelector('.pf-info');
    const button = info?.querySelector('.pf-info-trigger');
    const panel = info?.querySelector('.pf-info-panel');
    const language = header.querySelector('.pf-mobile-language');
    if (!button || !panel || button.dataset.pfInfoReady) return;
    button.dataset.pfInfoReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    let pinned = false, skipFocus = false;
    const position = () => {
      panel.style.top = matchMedia('(max-width: 600px)').matches ? `${button.getBoundingClientRect().bottom}px` : '';
      panel.style.setProperty('--pf-info-shift', '0px');
      const bounds = panel.getBoundingClientRect();
      const shift = bounds.left < 8 ? 8 - bounds.left : bounds.right > innerWidth - 8 ? innerWidth - 8 - bounds.right : 0;
      panel.style.setProperty('--pf-info-shift', `${shift}px`);
    };
    const setOpen = open => {
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      if (open) { if (language) language.open = false; position(); }
      else pinned = false;
    };
    const close = (focus = false) => {
      setOpen(false);
      if (focus) { skipFocus = true; button.focus(); queueMicrotask(() => { skipFocus = false; }); }
    };
    button.addEventListener('click', () => {
      const open = panel.hidden;
      setOpen(open); pinned = open;
    }, { signal });
    button.addEventListener('keydown', event => {
      if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault(); setOpen(true);
      const links = [...panel.querySelectorAll('a[href]')];
      (event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
    }, { signal });
    info.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) setOpen(true);
    }, { signal });
    info.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse' && !pinned && !info.contains(document.activeElement)) close();
    }, { signal });
    info.addEventListener('focusin', event => {
      if (event.target === button && button.matches(':focus-visible') && matchMedia('(max-width: 600px)').matches) button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (!skipFocus && (panel.contains(event.target) || button.matches(':focus-visible'))) setOpen(true);
    }, { signal });
    // Let the browser finish moving focus before deciding that it left the group.
    info.addEventListener('focusout', () => setTimeout(() => { if (!info.contains(document.activeElement)) close(); }, 0), { signal });
    info.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(true); } }, { signal });
    panel.addEventListener('click', event => { if (event.target.closest('a')) setTimeout(() => close(), 0); }, { signal });
    language?.addEventListener('toggle', () => { if (language.open) close(); }, { signal });
    header.addEventListener('keydown', event => {
      if (event.key === 'Escape' && language?.open) { language.open = false; language.querySelector('summary').focus(); }
    }, { signal });
    document.addEventListener('click', event => {
      if (!info.contains(event.target)) close();
      if (!header.contains(event.target) && language) language.open = false;
    }, { signal });
    window.addEventListener('resize', () => { if (!panel.hidden) position(); }, { signal });
    const followMobileTrigger = () => { if (!panel.hidden && matchMedia('(max-width: 600px)').matches) position(); };
    header.querySelector('.pf-primary-nav')?.addEventListener('scroll', followMobileTrigger, { signal, passive: true });
    window.addEventListener('scroll', followMobileTrigger, { signal, passive: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(header)) controller.abort(); }, { signal });
  });
}
initPfHeaderInfo();
document.addEventListener('shopify:section:load', event => initPfHeaderInfo(event.target));


  } catch(e) { console.error(e); }
})();
})();
